import React from 'react'
import { Classes } from '@blueprintjs/core'
import { Avatar, Flex, HighlightedText } from '..'
import { IEmployee } from '@api/types'
import api from '@api'
import GenericSelectWithInfiniteScroll, {
  SelectProps,
  ItemProps,
  ListFuc,
} from './GenericSelectWithInfiniteScroll'
import classnames from 'classnames'

type EmployeeSelectProps = SelectProps<IEmployee> & { list?: ListFuc<IEmployee> }

export default function EmployeeSelectWrapper(props: EmployeeSelectProps) {
  return (
    <GenericSelectWithInfiniteScroll<IEmployee>
      {...props}
      list={props.list || api.employee.search}
      Item={EmployeeItem}
    />
  )
}

export const EmployeeItem = ({ type, data, refItem, query }: ItemProps<IEmployee>) => {
  if (type === 'skeleton') {
    return (
      <Flex align="center" style={{ minWidth: 300, padding: '3px 0' }}>
        <Avatar skeleton size={Avatar.Size.XS} name="" assets={[]} />
        <div style={{ marginLeft: 10 }}>
          <span className={Classes.SKELETON}>First Last name</span>
          <div
            style={{
              fontSize: 12,
              lineHeight: '14px',
              color: 'var(--grey1)',
            }}
          >
            <span className={Classes.SKELETON}>first.last@companyname.com</span>
          </div>
        </div>
      </Flex>
    )
  }

  return (
    <div
      ref={refItem}
      className={classnames('flex items-center text-sm truncate', {
        'py-1': type !== 'value',
      })}
    >
      <Avatar
        size={type === 'value' ? Avatar.Size.XXS : Avatar.Size.XS}
        name={(data as IEmployee).name}
        assets={(data as IEmployee).assets}
      />
      <div className="ml-2 truncate">
        <span className="font-medium">
          <HighlightedText
            query={query}
            test={(data as IEmployee).name}
            text={(data as IEmployee).name}
          />
        </span>
        {type !== 'value' && (
          <div className="font-sm text-grey-600 truncate">
            <HighlightedText query={query} text={(data as IEmployee).email} />
          </div>
        )}
      </div>
    </div>
  )
}
